import React from 'react';
import PropTypes from 'prop-types';

import { useContext as useUsersContext } from 'components/Users/Context';
import useChannels from 'components/Common/Slack/Hooks/useChannels';

import { Outlet } from 'react-router-dom';
import { Formik, Form as FormikForm } from 'formik';
import SubmitButton from 'components/Widgets/SubmitButton';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Header from './Header';
import LoginInfo from './LoginInfo';
import RequestDelete from './RequestDelete';
import Calendars from './Calendars';
import MobileAppInfo from './MobileAppInfo';
import ChatBots from './ChatBots';

import Actions from './Actions';

export default function Content({ calendars }) {
  const { state: stateUsers } = useUsersContext();

  const channels = useChannels({ user: stateUsers.user });

  const member = stateUsers.user?.attributes?.specific;

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Settings',
    },
  ];

  const onSubmitHundler = (values, { setSubmitting }) => {
    Actions.updateCalendars({
      calendars: {
        google: values.googleCalendars,
        outlook: values.outlookCalendars,
      },
      google_calendar_id: values.googleCalendarId,
      outlook_calendar_id: values.outlookCalendarId,
      slack_channel_id: values.slackChannelId,
      slack_user_id: stateUsers.user.attributes.slack_user_id,
    }, (status) => {
      setSubmitting(false);
      if (status) {
        Alert({
          text: 'Your changes have been saved successfully.',
        });
      } else {
        Alert({
          text: 'Sorry, we can not update calendars, please contact support.',
        });
      }
    });
  };

  return (
    <div className="content member-setting-page">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <Header />

      <section>

        <Formik
          enableReinitialize
          initialValues={{
            googleCalendars: calendars.attributes.google_calendars
              .filter((item) => item.is_linked).map((item) => item.id),
            googleCalendarId: calendars.attributes.google_calendars
              .filter((item) => item.is_pushed).map((item) => item.id)[0],
            outlookCalendars: calendars.attributes.outlook_calendars
              .filter((item) => item.is_linked).map((item) => item.id),
            outlookCalendarId: calendars.attributes.outlook_calendars
              .filter((item) => item.is_pushed).map((item) => item.id)[0],
            slackChannelId: channels && channels.default_channel,
          }}
          onSubmit={onSubmitHundler}
        >

          {({ isSubmitting }) => (
            <FormikForm>
              <LoginInfo />

              {!stateUsers.user.attributes.is_mobile_login && (
                <>
                  <MobileAppInfo />
                  <Calendars calendars={calendars} />
                  {member?.slack_enabled
                    && <ChatBots channels={channels} isLoaded={channels !== undefined} />}
                  <RequestDelete />
                  <div className="d-flex justify-content-end">

                    <SubmitButton
                      loading={isSubmitting}
                    >
                      Save
                    </SubmitButton>
                  </div>
                </>
              )}

            </FormikForm>
          )}

        </Formik>
      </section>

      <Outlet />

    </div>
  );
}

Content.propTypes = {
  calendars: PropTypes.object,
};

Content.defaultProps = {
  calendars: null,
};
